import { Language } from 'interfaces/language';
import { languageOptions } from 'languages';

export function formatUserLanguage(userLanguage: Language): Language {
  const defaultUserLanguage: Language = 'en';

  if (userLanguage in languageOptions) {
    return userLanguage;
  }

  return defaultUserLanguage;
}
